import ReactPaginate from "react-paginate";

export function Pagination({
  pageCount,
  onPageChange,
  page,
  pageRange = 1,
}: {
  pageCount: number;
  onPageChange: (page: number) => void;
  page: number;
  pageRange?: number;
}) {
  return (
    <div className="pagination-container">
      <p>
        Page {page + 1} of {pageCount}
      </p>
      <ReactPaginate
        breakLabel="..."
        pageCount={pageCount}
        pageRangeDisplayed={pageRange}
        previousLabel="Previous"
        nextLabel="Next"
        onPageChange={(selectedItem) => onPageChange(selectedItem.selected)}
        renderOnZeroPageCount={null}
        forcePage={page}
        marginPagesDisplayed={pageRange}
      />
    </div>
  );
}
